module.exports = __webpack_public_path__ + "img/23.074249c9.png";